(()=>{
 if(window.gt26Conversion)return;window.gt26Conversion=true;
 const hero=document.querySelector('.gt24-root');
 const source=hero?.querySelector('a[href*="/products/adventskalender"]');
 if(!source)return;
 const bar=document.createElement('div');bar.className='gt26-sticky-order';bar.hidden=true;
 const link=document.createElement('a');link.href=source.href;link.innerHTML='Jetzt bestellen · ab 24 € <span aria-hidden="true">→</span>';bar.append(link);document.body.append(bar);
 const mobile=matchMedia('(max-width:800px)');
 const visible=e=>{const r=e.getBoundingClientRect(),s=getComputedStyle(e);return r.width>0&&r.height>0&&r.bottom>0&&r.top<innerHeight&&s.visibility!=='hidden'&&s.display!=='none';};
 let queued=false;
 function update(){queued=false;
  document.body.classList.toggle('gt26-sticky-space',mobile.matches);
  const ctas=[...document.querySelectorAll('a[href*="/products/adventskalender"]')].filter(e=>!bar.contains(e)&&!e.closest('header'));
  const overlay=[...document.querySelectorAll('[aria-modal="true"],dialog[open],#onetrust-banner-sdk,#CybotCookiebotDialog,.shopify-pc__banner')].some(visible);
  const editing=/INPUT|TEXTAREA|SELECT/.test(document.activeElement?.tagName||'');
  bar.hidden=!mobile.matches||source.getBoundingClientRect().bottom>0||ctas.some(visible)||overlay||editing;
 }
 const schedule=()=>{if(!queued){queued=true;requestAnimationFrame(update);}};
 addEventListener('scroll',schedule,{passive:true});addEventListener('resize',schedule);document.addEventListener('focusin',schedule);document.addEventListener('focusout',schedule);
 new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['open','aria-hidden','aria-modal']});
 update();
})();
